import { Button } from '../Button/Button'
import { Heading } from '../Heading/Heading'
import { useTranslate } from '../../TranslationsContext'
import { Container } from '../Container/Container'
import './UnderCover.css'

export function UnderCover() {
  const translate = useTranslate()
  const urlDiscoverMore = translate('UnderCover.cta.url')
  const content2 = translate('UnderCover.content.2')

  return (
    <div className="UnderCover">
      <Container>
        <Heading type="Paragraph">
          {translate('UnderCover.title.1')}
          <br />
          {translate('UnderCover.title.2')}
        </Heading>
        <p>
          {translate('UnderCover.content.1.beforeBold')}
          <strong>{translate('UnderCover.content.1.bold.1')}</strong>
          {translate('UnderCover.content.1.afterBold.1')}
          <strong>{translate('UnderCover.content.1.bold.2')}</strong>
          {translate('UnderCover.content.1.afterBold.2')}
          <strong>{translate('UnderCover.content.1.bold.3')}</strong>
          {translate('UnderCover.content.1.afterBold.3')}
        </p>
        {content2 === 'UnderCover.content.2' ? (
          <></>
        ) : (
          <p className="buttonLike">{translate('UnderCover.content.2')}</p>
        )}
        {urlDiscoverMore !== 'UnderCover.cta.url' ? (
          <Button
            type="Link"
            url={translate('UnderCover.cta.url')}
            label={translate('Cta.discoverMore')}
            target="_blank"
            rel="noreferrer"
          />
        ) : (
          <></>
        )}
      </Container>
    </div>
  )
}
